import tc from "common/common/tcHelpers";
import { T, curry, map, filter, forEach, pipe } from "ramda";
import angular from "angular";

angular.module("ticketco/common/arena").directive("tcArena", arenaDirective);

function arenaDirective() {
  function link(scope, elem) {
    scope.$sections = tc.dom.queryAll(
      "[tc\\:role=Section], [tc\\:role=SectionDecor]",
      elem[0]
    );

    function clickHandler(e) {
      var name = $(this)
        .children("[tc\\:role='Section'], [tc\\:role='SectionDecor']")
        .attr("tc:name");
      // We depend on hrefs like "sections/603"
      var id = ($(this).attr("xlink:href") || "").split("/")[1];
      scope.arenaClick({ $id: id, $name: name, $event: e });
      tc.dom.dispatch("section:click", { name: name }, document.body);
    }

    $(elem).on("click", "a", clickHandler);

    // Destructor
    elem.on("$destroy", function () {
      $(elem).off("click", clickHandler);
    });
  }

  function controller($scope) {
    this.$getSections = $scope.$getSections = function (filterPredicate) {
      return filter(filterPredicate || T, $scope.$sections);
    };

    this.mapSectionLinks = $scope.mapSectionLinks = curry(function (fn, xs) {
      pipe(
        map(tc.dom.parent),
        filter((el) => tc.dom.getAttr("xlink:href", el) != null),
        forEach((el) => tc.dom.setAttr("xlink:href", fn(el), el))
      )(xs);
      return xs;
    });
  }

  return {
    scope: {
      arenaClick: "&",
      promocode: "@",
      activeItemType: "<",
    },
    link: link,
    controller: controller,
  };
}
